<template>
    <div class="container-2 border">
        <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="grey"
            :size="40"
            style="margin-right: 16px; height: 100vh;"
        ></v-progress-circular>
        <div v-else class="container-2" style="flex-direction: column; padding-bottom: 24px;">
            <div class="eligibleAmount">
                <div class="title">
                    Total Eligible for withdrawal
                </div>
                <div class="amount">
                    &#x20B9;{{ withdrawableAmount | localeAmountPaisaToRupee }}
                </div>
            </div>
            <div v-if="withdrawableAmount" class="eligibility">
                <img src="/img/solid_info.png" alt="">
                <span style="font-size: 10px; color: #F6F3F3;">
                    Withdrawals are permitted for investments that have surpassed their one-year lock-in period. The total principal balance of all the loans in which the lender has participated is used to determine the withdrawal amount.
                </span>
            </div>
            <div class="withdrawalTitle">
                Withdrawal Summary
            </div>

            <div class="data">
                <div class="dataRow">
                    <div class="dataTitle">
                        <div class="heading">
                            Invested Amount
                        </div>
                        <div class="small">
                            Unlocked as on {{ new Date() | formatDate }} for your {{ portfolio.planType | capitalize }} {{ portfolio.riskProfile | capitalize }} porfolio.
                        </div>
                    </div>
                    <div class="smallAmount">
                        &#x20B9;{{ portfolio.idealUnlockedAmount | localeAmountPaisaToRupee}}
                    </div>
                </div>
                <div class="dataRow">
                    <div class="dataTitle">
                        <div class="heading">
                            Withdrawn
                        </div>
                        <div class="small">
                            Amount withdrawn by you previously.
                        </div>
                    </div>
                    <div class="smallAmount">
                        &#x20B9;{{ portfolio.withdrawnAmount | localeAmountPaisaToRupee}}
                    </div>
                </div>
                <div class="dataRow">
                    <div class="dataTitle">
                        <div class="heading">
                            Unallocated Amount
                        </div>
                        <div class="small">
                            This amount is not allocated to any borrower yet.
                        </div>
                    </div>
                    <div class="smallAmount">
                        &#x20B9;{{ portfolio.unallocatedAmount | localeAmountPaisaToRupee }}
                    </div>
                </div>
                <div class="dataRow" v-if="portfolio.totalEarnings">
                    <div class="dataTitle">
                        <div class="heading">
                            Earnings
                        </div>
                        <div class="small">
                            Your accumulated interest as per your chosen plan type & risk profile.
                            <span v-if="portfolio.planType === 'income'">
                                This is credited directly into your bank account at the end of the month.
                            </span>
                        </div>
                    </div>
                    <div class="smallAmount">
                        &#x20B9;{{ portfolio.totalEarnings | localeAmountPaisaToRupee }}
                    </div>
                </div>
                <div class="dataRow">
                    <div class="dataTitle">
                        <div class="heading">
                            Ineligible Amount
                        </div>
                        <div class="small">
                            The principal amount of loans with past-due EMIs.
                        </div>
                    </div>
                    <div class="smallAmount">
                        &#x20B9;{{ portfolio.ineligibleAmount | localeAmountPaisaToRupee }}
                    </div>
                </div>
            </div>
               <!--
            <div class="dataRow">
                <div class="dataTitle">
                    <div class="heading">
                        <strong>
                            Total Eligible for withdrawal
                        </strong>
                    </div>
                    <div class="small">
                        <div>
                            Your investment has been divided among various loans, so withdrawals will be limited to the
                            nearest lower range of the sum of the principal outstanding for each loan.
                        </div>
                    </div>
                </div>
                <div>
                    <strong>
                        &#x20B9;{{ withdrawableAmount | localeAmountPaisaToRupee }}
                    </strong>
                </div>
            </div> -->

            <div class="pt-20" style="width: 60%">
                <button class="withdrawButton" @click="withdrawPortfolio(portfolio)" :disabled="isWithdrawLoading || !withdrawableAmount">
                    <span v-if="!isWithdrawLoading">
                        Withdraw
                    </span>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="grey"
                        :size="20"
                        style="margin-right: 16px"
                    ></v-progress-circular>
                </button>
            </div>

            <div class="pt-10" style="width: 60%;">
                <button class="investButton" @click="goToInvest">
                    <div>
                        Invest More
                    </div>
                    <div class="small" v-if="portfolio.totalEarnings">
                        You are currently earning at {{ getReturns }}%
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import LenderService from '@/services/lenderService'

export default {
    name: 'PortfolioWithdrawalSummary',
    props: {
        selectedPortfolio: {
            type: Object
        }
    },
    data () {
        return {
            profileImage: '/img/profile.jpg',
            portfolio: null,
            withdrawableAmount: 0,
            isLoading: false,
            isWithdrawLoading: false
        }
    },
    mounted () {
        window.scrollTo(0, 24)
        this.profileImage = this.$store.state.dashboard.profileImage
        this.getWithdrawalSummary()
    },
    computed: {
        getReturns () {
            return this.portfolio.lenderPercentage
        }
    },
    methods: {
        getWithdrawalSummary () {
            this.$store.commit('isLoading', { message: 'We are calculating your withdrawal amount!' })
            const queryString = 'portfolioId=' + this.selectedPortfolio.portfolioId
            LenderService.getWithdrawalSummary(queryString).then((response) => {
                this.portfolio = response.data.portfolio
                this.withdrawableAmount = response.data.withdrawableAmount

                if (!this.withdrawableAmount) {
                    this.isWithdrawLoading = true
                }
                this.$store.commit('isNotLoading')
            })
        },
        withdrawPortfolio (portfolio) {
            this.$emit('confirmWithdrawPortfolio', portfolio, this.withdrawableAmount)
        },
        goToInvest () {
            this.$router.push('/select-plan')
        }
    }
}
</script>

<style lang="scss" scoped>
    .container-2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .withdrawalTitle {
        font-style: normal;
        font-weight: 700;
        font-size: 17px;
        line-height: 24px;
        text-align: left;
        width: 90%;
        padding: 24px 0px;
    }

    .heading {
        font-size: 13px;
        text-transform: capitalize;
    }

    .small {
        font-size: 11px;
        line-height: 1;
        color: #8c8c8c;
    }

    .smallAmount {
        font-size: 13px;
    }

    .profileImage {
        img {
            width: 42px;
            height: 42px;
            border-radius: 50%;
        }
    }

    .amount {
        font-size: 28px;
        padding-top: 4px;
        color: #232323;
    }

    .dataRow {
        width: 90%;
        display: flex;
        justify-content: space-between;
        padding-bottom: 24px;
    }

    .dataTitle {
        width: 70%;
    }

    button {
        padding: 11px 24px;
        border-radius: 6px;
        letter-spacing: 0.005em;
        font-size: 14px;
        line-height: 150%;
        font-weight: 600;
        width: 100%;

    }

    .withdrawButton {
        background: #002FA7;
        color: #FFFFFF;
        padding: 12px 24px;
    }

    .investButton {
        border: 1.5px solid #002FA7;
        color: #002FA7;
        padding: 6px 12px;
        padding-top: 5px;
    }

    .tooltipContainer {
        padding: 16px !important;
        box-shadow: 5px 20px 24px -4px rgba(16, 24, 40, 0.1), 5px 8px 8px -4px rgba(16, 24, 40, 0.04);
        background-color: #ffffff !important;
    }

    .tooltipSubContainer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .v-tooltip__content {
        opacity: 1 !important;
        text-align: center !important;
        padding: 16px !important;
        box-shadow: 5px 20px 24px -4px rgba(16, 24, 40, 0.1), 5px 8px 8px -4px rgba(16, 24, 40, 0.04);
    }

    .earningsText {
        text-align: center;
        margin-bottom: 4px !important;
        font-weight: 600;
        font-size: 16px;
        color: #0f0f0f
    }
    .spanText {
        color: #8c8c8c;
        text-align: center !important;
        font-size: 11px !important
    }
    .cautionImage {
        margin-left : 10px;
        width: 16px !important;
        height: 16px !important;
        cursor: pointer;
    }

    .eligibleAmount {
        background: #002FA7;
        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.05);
        padding: 24px;
        color: #E0E0E0;
        width: 100%;

        .title {
            font-size: 12px !important;
        }

        .amount {
            display: flex;
            align-items: center;
            font-size: 32px;
            color: #FFFFFF;
        }

        span {
            font-size: 11px;
        }
    }

    .eligibility {
        display: flex;
        align-items: center;
        justify-content: center;
        background:  #045DD3;
        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.05);
        padding: 4px 24px;
        width: 100%;

        span {
            padding: 6px 12px;
        }
    }

    .data {
        border: 1px solid #E8EAED;
        border-radius: 10px;
        padding: 16px 12px;
        margin: 0px 18px;
        width: 90%;
    }

    .border {
        width: 100%;
    }
</style>
